export default __webpack_public_path__ + "static/12.05-90adabd0225522156115cd5af0a522a3.png";